import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createWeightSetting, getWeightSetting } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializeWeightSettingForm, formInput } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import { selectWeightSettingModel } from 'selectors/entitySelector';
import { measurementEditCrumb, measurementAddCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import WeightInput from 'screens/components/basic/WeightInput';
import Grid from 'screens/components/basic/Grid';

class MeasurementSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: null
        };
    }

    // control if is ADD or EDIT
    componentWillMount() {
        const weightId = this.props.params ? this.props.params.id : 0;
        //if true dispatch an action to retrive data from API and set Status to EDIT
        if (weightId) {
            this.setState({ status: "EDIT" });
            this.props.getWeightSetting(weightId);
        }
        //if false dispatch an action to clean the form and set default values and set Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
    }

    // is SUCCEEDED or FAILED
    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }

        if (newProps.weightSettingModel && this.props.weightSettingModel !== newProps.weightSettingModel) {
            if (this.props.weightSettingModel.UnitOfMeasurement !== newProps.weightSettingModel.UnitOfMeasurement) {
                this.props.formInput('', `${this.props.name}Measurement`);
            }
        }
    }

    //when data is saved successfully
    saveSuccess = () => {
        this.redirectToListWeightSetting();
        this.props.showSuccess(this.state.status === "EDIT" ? LOOKUP.weight.messages.editedMessage : LOOKUP.weight.messages.createdMessage);
    }

    //when data is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.weight.messages.saveErrorMessage);
    }

    saveWeightSetting = () => {
        const weightSetting = this.props.weightSettingModel;
        this.props.createWeightSetting(weightSetting);
    }

    redirectToListWeightSetting = () => {
        this.props.navigate("/manage/measurement");
    }

    render() {
        const p = this.props;
        const title = this.state.status === 'ADD' ? "Add Measurement Settings" : "Edit Measurement Settings";
        const breadCrumbPage = this.state.status === 'EDIT' ? measurementEditCrumb : measurementAddCrumb

        return (
            <Grid headerContent={breadCrumbPage}>
                <PageHeader title={title} />
                <CardSimple className="p-1">
                    <div className="row m-0">
                        <div className="col-lg-6">
                            {
                                this.state.status === "EDIT" ? (<TextInput name={p.name + "Id"}
                                    label={LOOKUP.weight.id.label}
                                    floatingLabelText={LOOKUP.weight.id.label}
                                    hintText={LOOKUP.weight.id.hintText}
                                    disabled={true}
                                    fullWidth={true} />) : null
                            }
                        </div>
                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <ToggleInput className="measurement_status btnToggleLabel" name={`${p.name}Status`} label={LOOKUP.weight.status.label} />
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="col-lg-6">
                            <TextInput name={`${p.name}Name`}
                                fullWidth={true}
                                floatingLabelText={LOOKUP.weight.name.label}
                                label={LOOKUP.weight.name.label}
                                hintText={LOOKUP.weight.name.hintText}
                                maxLength={50}
                                required />
                        </div>
                        <div className="col-lg-6">
                            <WeightInput
                                name={`${p.name}Measurement`}
                                fullWidth={true}
                                floatingLabelText={LOOKUP.weight.weight.label}
                                label={LOOKUP.weight.weight.label}
                                hintText={LOOKUP.weight.weight.hintText}
                                min={0} max={LOOKUP.weight.maximumWeight}
                                required />
                        </div>
                    </div>
                </CardSimple>
                <PageBottomWithButtons>
                        <Button
                            name="saveButton"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.weight.controls.saveButton}
                            primary={true}
                            onTouchTap={() => this.saveWeightSetting()} />
                        <Button
                            type="CancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.redirectToListWeightSetting()} />
                </PageBottomWithButtons>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        weightSettingModel: selectWeightSettingModel(state, props.name),
        saveSuccess: state.form[props.name + "SaveSuccess"]
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        init: (name) => dispatch(initializeWeightSettingForm(name)),
        createWeightSetting: (weightSetting) => dispatch(createWeightSetting(weightSetting, props.name)),
        getWeightSetting: (weightSettingId) => dispatch(getWeightSetting(weightSettingId, props.name)),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(MeasurementSave));